import axios from 'axios';
import { Dialog } from 'vant';
import md5 from 'js-md5';
// create an axios instance
const Axios = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'https://dev-gateway.etc-parts.com/',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000,
});
// request interceptor
Axios.interceptors.request.use(
  (config) => {
    if (config.method === 'post' || config.method === 'put') {
      config.headers['x-auth-sign'] = md5(JSON.stringify(config.data) + 'ETC-PARTS-KEY');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// response interceptor
Axios.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res && res.success) {
      return Promise.resolve(res);
    }
  },
  (error) => {
    Dialog.alert({
      message: error.response.data.message,
      theme: 'round-button',
      confirmButtonText: '关闭',
    }).then(() => {
      window.WeixinJSBridge.call('closeWindow');
    });

    return Promise.reject(error.response.data);
  }
);
export default Axios.request;
